/*
    This file is part of Universal Sequencer.
    Universal Sequencer is free software: you can redistribute it and/or modif
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Universal Sequencer is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/


import React, { Component } from 'react';
import { Group, Stage, Layer, Rect, Line} from 'react-konva';
import AudioUnit from 'engine/audio.js';
import crop from 'Crop.js';
import Tone from 'tone';

const WIDTH_PER_SECONDS = 150; 

class SimpleWaveform extends Component {
    constructor(props) {
        super(props);
        this.state = {
            buffer: props.buffer,
            sound: props.sound,
            previousBuffer: undefined,
            x: 0,
            isPlaying: false,
            dragging: false,
            selection:null,
            bufferDuration: undefined,
        };
        this.width = props.width || 825;
        this.height = props.height || 115;
        this.state.pts = [];
        var self = this;
        this.computeWaveformInChunks(0, [], function(pts) {
            self.state.pts = pts;
            self.setState(self.state);
        });
        this.convertSpaceToSeconds.bind(this);
        this.audioUnit = new AudioUnit(Tone.context);
    }

    getWidth() {
        let width = this.state.buffer.duration * WIDTH_PER_SECONDS;

        if (width > this.width) {
            return this.width;
        }

        return width;
    }

    // since drawing is slow only do it when waveform changes
    shouldComponentUpdate(nextProps) {
        if (this.state.bufferDuration !== nextProps.buffer.duration) {
            this.state.buffer = nextProps.buffer;
            this.state.bufferDuration = nextProps.buffer.duration;
            var self = this;
            this.computeWaveformInChunks(0, []);
        }
        return true; 
    }

    async computeWaveformInChunks(chunkNumber, prevList, callback) {
        const chunkSize = this.getWidth(); 
        var step = Math.floor(this.state.buffer.length / this.getWidth());
        var channel = this.state.buffer.getChannelData(0);
        let p = window.api.create_buffer(channel.length);
        window.Module.HEAPF32.set(channel, p >> 2);
        window.api.getWaveform(p, chunkSize, this.height, channel.length, step, chunkSize*chunkNumber);
        const resultPointer = window.api.get_result_pointer();
        const resultView = new Uint16Array(window.Module.HEAP16.buffer, resultPointer, chunkSize*7);

        let list = [];

        for (var i=0; i < chunkSize*4 ; i+=4) {
            list.push({x:resultView[i], y: resultView[i+1], width: resultView[i+2], height: resultView[i+3]});
        }
        var self = this;
        this.state.pts = list;
        this.setState(this.state);

        window.api.destroy_buffer(p);
    };

    convertSpaceToSeconds(x) {
       return this.state.buffer.duration * x / this.getWidth();
    }

    convertSecondsToSpace(x) {
        return x / this.state.buffer.duration * this.getWidth();
    }

    convertSamplesToSpace(x) {
        return this.convertSecondsToSpace((1.0 * x) / Tone.Master.context.sampleRate);
    }

    onClick() {
        this.audioUnit.loadRawBuffer(this.state.buffer);
        let isPlaying = !this.state.isPlaying;
        this.setState({isPlaying: isPlaying});
        if (isPlaying) {
            if (this.props.sound.slices !== undefined &&
                this.props.sound.slices.length > 0) {
                let slice = this.props.sound.slices[0];
                let start = slice.startTime;
                let dur = slice.endTime - slice.startTime;
                this.audioUnit.playSound(start, dur);
            } else {
                this.audioUnit.playSound(0);
            }
        } else {
            this.audioUnit.stopSound();
        }
        this.props.onClick();
    }

    onDragStart(e) {
        this.props.dragging(this.state.sound);
    }

    onDragOver(e) {
        e.preventDefault();
    }

    render() {
        var pts = this.state.pts; 
        var self = this;
        let width = this.width + 20;
        let thumbnail = this.props.sound === undefined ? undefined : this.props.sound.getThumbnail();
        let name = this.props.sound === undefined ? undefined : this.props.sound.name;
        let slices = this.props.sound === undefined ? [] : this.props.sound.slices === undefined ? [] : this.props.sound.slices;

        console.log('simplewaveform.segmetns = ');
        console.log(this.props.segments);

        return (
            <div
                className="draggable-waveform"
                onDragStart={(e) => this.onDragStart(e)}
                onDragOver={(e) => this.onDragOver(e)}
                draggable
              >
              <div
                 onClick={() => this.onClick()}
                className={this.props.isSelected ? "selected sound-waveform waveform" : "sound-waveform waveform"}
                style={{width: width + 'px'}}>
                <Stage width={this.width} height={this.height}>
                  
                  <Layer>
                    <Group>
                      
                      <Rect x={0} y={0} width={this.width} height={this.height} fill='black'/>
                      {this.props.segments.map(
                          (segment) =>
                              <Rect x={this.convertSamplesToSpace(segment.start)}
                                        y={0}
                                        width={this.convertSamplesToSpace(segment.end - segment.start)}
                                        height={this.height}
                                    fill={'#001821'}/>)}
            {slices.map(
                (slice, i) =>
                    <Rect x={this.convertSecondsToSpace(slice.startTime)}
                y={0}
                width={this.convertSecondsToSpace(slice.endTime - slice.startTime)}
                height={this.height}
                fill='yellow'/>)}
            {pts.map(
                (pt) =>
                    <Rect x={pt.x} y={pt.y} width={pt.width} height={pt.height} fill={'red'}/>)}
                <Line x={this.state.x} y={0} points={[this.state.x, 0, this.state.x, this.height] } strokeWidth={1} stroke="red" fill="red"/>
                </Group>
                </Layer>
                </Stage>
                
            </div>
                {!this.props.isMainWaveform ?
                 <div onClick={() => this.props.onClick()} className="sound-details">
                 <span className="delete-button" onClick={() => this.props.onClickDelete()}>x</span>
                 {thumbnail !== undefined ?
                  <img
                  className='video-thumbnail'
                  src={thumbnail}/> : ''}
                 <div className={thumbnail === undefined ? "just-sound-name sound-name" : "sound-name"}>{name !== undefined ? truncateName(name) : ''}</div>
                </div>
                 :''}
                </div>
        );
    }
}

const maxNameLength = 14;;
function truncateName(str) {
    if (str === undefined || str === null) {
        return null;
    }
    return str.length > maxNameLength ? str.substring(0, maxNameLength) + '...' : str;
}


export default SimpleWaveform;
